export default __webpack_public_path__ + "static/media/bloodyhack2.8d771c51.png";